exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedbackLabel[data-v-c39c65b0]{width:90px;padding:3px 0;border-radius:20px;color:#fff;font-size:13px;text-align:center;box-sizing:border-box}", ""]);

// exports
